import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// CSS styling
import "../../styles/activitiesPublic.css";

// Axios and API
import { fetchActivities } from "../../api/fetchActivities";

// React Slideshow Image
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

// Helpers
import { capitalizeFirstLetter } from "../../helpers/capitalizeFirstLetter.js";
import { SITE_URL, absoluteUrl, activityPath } from "../../helpers/seo";

// Components
import Seo, { organizationRef } from "../../components/Seo.js";
import Header from "../../components/Header.js";
import Footer from "../../components/Footer.js";
import Loader from "../../components/Loader";

// React lottie
import Lottie from "react-lotties";
import PaperPlane from "../../lotties/paperplane.json";

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [viewAllActivities, setViewAllActivites] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  // React lotties
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: PaperPlane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const fetchAllActivities = async (props, hideBtnSeeMore) => {
    try {
      setIsLoading(true);
      setLoading(true);
      let params = null;
      if (props && props.limit) {
        params = { limit: props.limit };
      }

      const response = await fetchActivities(params);

      if (response && response.status === 200 && response.data) {
        const { data = [] } = response || {};
        setActivities(data);
      }
    } catch (err) {
      console.log(err, "err <<<");
    } finally {
      setIsLoading(false);
      setLoading(false);
      if (hideBtnSeeMore) {
        setViewAllActivites(true);
      }
    }
  };

  useEffect(() => {
    fetchAllActivities({ limit: 12 });
  }, []);

  const buttonStyle = {
    position: "absolute",
    zIndex: "1",
    cursor: "pointer",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: "#000000",
    fontSize: "80px",
    padding: "20px",
    borderRadius: "50%",
  };

  const properties = {
    prevArrow: (
      <button className="arrow arrow-left" style={{ ...buttonStyle, left: 0 }}>
        <span>&lt;</span>
      </button>
    ),
    nextArrow: (
      <button
        className="arrow arrow-right"
        style={{ ...buttonStyle, right: 0 }}
      >
        <span>&gt;</span>
      </button>
    ),
  };

  return (
    <div id="activityPublic">
      <Seo
        title="Sustainability Activities & Events"
        description="See what the Institute for Sustainability and Agility (ISA) has been doing: our latest sustainability and ESG activities, events, talks and projects."
        path="/activities"
        breadcrumbs={[{ name: "Activities", path: "/activities" }]}
        jsonLd={{
          "@type": "CollectionPage",
          name: "Sustainability Activities & Events",
          description:
            "Latest sustainability and ESG activities, events, talks and projects from the Institute for Sustainability and Agility (ISA).",
          url: absoluteUrl("/activities"),
          isPartOf: { "@id": `${SITE_URL}/#website` },
          publisher: organizationRef,
        }}
      />
      <Header />
      <div className="activityPublicListContainer">
        <div className="activityPublicCardListContainer">
          <div className="activityTitle header">
            <h1 className="seoH1 seoH1Inherit">Activities</h1>
          </div>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Lottie options={lottieOptions} height={200} width={400} />
              <h4
                style={{
                  color: "#0D4C86",
                }}
              >
                LOADING
              </h4>
              <p
                style={{
                  color: "#0D4C86",
                }}
              >
                Processing your request, please wait...
              </p>
            </div>
          ) : (
            <div className="activityPublicListCards">
              {activities &&
                Array.isArray(activities) &&
                activities.length > 0 &&
                activities.map((activity, index) => {
                  const {
                    id,
                    title,
                    activityType,
                    link,
                    ActivityImages,
                    ActivityTags,
                    input_summary,
                  } = activity || {};
                  return (
                    <div className="activityPublicListEachCard" key={id}>
                      <div>
                        {ActivityImages &&
                        Array.isArray(ActivityImages) &&
                        ActivityImages.length > 1 ? (
                          <Slide {...properties}>
                            {ActivityImages.map((slideImage, idx) => {
                              return (
                                <div
                                  key={slideImage.id}
                                  className="activityPublicCardPicture"
                                >
                                  <img
                                    key={idx}
                                    src={slideImage?.img_url}
                                    alt={`${capitalizeFirstLetter(title)} (${idx + 1})`}
                                    loading="lazy"
                                  />
                                </div>
                              );
                            })}
                          </Slide>
                        ) : ActivityImages &&
                          Array.isArray(ActivityImages) &&
                          ActivityImages.length === 1 ? (
                          <div className="activityPublicCardPicture">
                            <img
                              src={ActivityImages[0]["img_url"]}
                              alt={capitalizeFirstLetter(title)}
                              loading="lazy"
                            ></img>
                          </div>
                        ) : null}
                      </div>
                      <div className="activityPublicCardTitle">
                        <p className="title">
                          <Link to={activityPath({ id, title })}>
                            {capitalizeFirstLetter(title)}
                          </Link>
                        </p>
                      </div>
                      <div
                        className="activityPublicCardType paragraf"
                        style={{ lineHeight: "30px" }}
                      >
                        <p>{capitalizeFirstLetter(activityType)}</p>
                      </div>
                      <div
                        className="activityPublicCardDescription paragrafDesc"
                        style={{ lineHeight: "30px" }}
                      >
                        <p>{input_summary}</p>
                      </div>
                      {ActivityTags &&
                      Array.isArray(ActivityTags) &&
                      ActivityTags.length > 0 ? (
                        <div style={{ marginTop: "20px" }}>
                          <div className="blogCardTags paragraf">Tags:</div>
                          {ActivityTags.map((tag) => {
                            if (tag && tag.TagId) {
                              return (
                                <div
                                  className="blogCardTagsBoxContainer"
                                  key={tag.id}
                                >
                                  <div className="blogCardTagsBox paragrafDesc">
                                    <p>
                                      {capitalizeFirstLetter(
                                        tag?.Tag?.tag_name,
                                      )}
                                    </p>
                                  </div>
                                </div>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </div>
                      ) : null}
                      {link ? (
                        <div style={{ marginTop: "20px" }}>
                          <div className="blogCardTags paragraf">Link</div>
                          <div className="blogCardTagsBoxContainer paragrafDesc">
                            <a
                              href={`https://${link}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link}
                            </a>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
            </div>
          )}
          {!viewAllActivities ? (
            <div
              className="buttonDownloadHereDiplomaESGContainer"
              style={{ marginBottom: "3em" }}
            >
              <button
                className="btn paragraf"
                onClick={() => fetchAllActivities(null, true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isLoading ? (
                  <Loader
                    type="spin"
                    color="black"
                    height="35px"
                    width="35px"
                  />
                ) : (
                  "See more"
                )}
              </button>
            </div>
          ) : null}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Activities;
